const OUTLINE_PROPS = new Set(["color"]);

export function createColorRenderer() {
  return function colorRenderer(
    _instance: any,
    td: any,
    _row: any,
    _col: any,
    prop: any,
    value: any,
  ) {
    while (td.firstChild) {
      td.removeChild(td.firstChild);
    }

    td.style.textAlign = "center";
    td.style.verticalAlign = "middle";

    const container = document.createElement("div");
    container.style.display = "flex";
    container.style.alignItems = "center";
    container.style.justifyContent = "center";
    container.style.height = "100%";

    const color = typeof value === "string" ? value : "";
    const isOutline = OUTLINE_PROPS.has(prop);

    if (color) {
      const swatch = document.createElement("div");
      swatch.className = "em-color-swatch";
      const fill = document.createElement("div");
      fill.className = "em-color-swatch__fill";
      if (isOutline) {
        fill.style.backgroundColor = "transparent";
        fill.style.boxShadow = `inset 0 0 0 3px ${color}`;
      } else {
        fill.style.backgroundColor = color;
      }
      swatch.appendChild(fill);
      container.appendChild(swatch);
    } else {
      const placeholder = document.createElement("span");
      placeholder.className = "em-color-placeholder";
      placeholder.textContent = isOutline ? "Definir cor" : "Herda da borda";
      container.appendChild(placeholder);
    }

    td.appendChild(container);
    td.title = color || "";
  };
}
